export default __webpack_public_path__ + "static/media/070_boost.1fbfeffb.mp4";